/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import dashBoard from "../assets/dashboard.svg";
import docAccess from '../assets/docaccessibility.svg';
import avAccess from '../assets/avaccessibility.svg';
import careerDiscovery from '../assets/careerdiscovery.svg';
import jobList from '../assets/joblist.svg';
import info from '../assets/infoaccess.svg';
import news from '../assets/news.svg';
import library from '../assets/library.svg';
import dashboardActive from '../assets/dashboard-active.svg';
import docAccessActive from '../assets/docaccessibility-active.svg';
import avAccessActive from '../assets/avaccessbility-active.svg';
import careerDiscoveryActive from '../assets/careerdiscovery-active.svg';
import jobListActive from '../assets/joblist-active.svg';
import infoActive from '../assets/infoaccess-active.svg';
import newsActive from '../assets/news-active.svg';
import libraryActive from '../assets/library-active.svg';
import user from "../assets/user.svg";
import useWindowWidth from "../utils/windowWidth";
import logout from '../assets/logout.svg';
import nclude from "../assets/nclude-logo.svg";
import AccessibilityAccordion from "./AccessibilityAccordion";
import browserAgent from '../assets/link-45deg.svg';
import browserAgentActive from '../assets/link-45deg.svg';


// Define the props interface
interface props {
  activePage: string;
}

function SideBar(props: props) {
  const navigate = useNavigate();
  const location = useLocation();
  const active = props.activePage;
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const closeButtonRef = useRef<HTMLButtonElement>(null);
  const openButtonRef = useRef<HTMLButtonElement>(null);
  const navRef = useRef<HTMLElement>(null);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
    window.setTimeout(() => openButtonRef.current?.focus(), 0);
  };

  const handleLogout = () => {
    if (localStorage.getItem("token")) {
      localStorage.removeItem("token");
      localStorage.removeItem("resume");
      localStorage.removeItem("scope");
      navigate("/login");
    }
  };

  const windowWidth = useWindowWidth();
  const isMobile = windowWidth < 769;

  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (!isMobile || !sidebarOpen) return;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    closeButtonRef.current?.focus();

    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") closeSidebar();

      if (event.key === "Tab") {
        const focusable = navRef.current?.querySelectorAll<HTMLElement>(
          "a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex='-1'])"
        );
        if (!focusable?.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    };

    document.addEventListener("keydown", handleEscape);
    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener("keydown", handleEscape);
    };
  }, [isMobile, sidebarOpen]);

  return (
    <>
      {isMobile && !sidebarOpen && (
        <button
          ref={openButtonRef}
          type="button"
          className="hamburger mobile-menu-trigger"
          onClick={toggleSidebar}
          aria-label="Open main menu"
          aria-expanded={sidebarOpen}
          aria-controls="primary-navigation"
        >
          <span aria-hidden="true">☰</span>
          <span>Menu</span>
        </button>
      )}
      {isMobile && sidebarOpen && (
        <button className="sidebar-backdrop" type="button" onClick={closeSidebar} aria-label="Close main menu" />
      )}
      <nav
        ref={navRef}
        id="primary-navigation"
        className={`sidebar ${sidebarOpen ? "active" : ""}`}
        aria-label="Main navigation"
        aria-hidden={isMobile && !sidebarOpen}
      >
        {isMobile && (
          <div className="mobile-nav-header">
            <img src={nclude} alt="Nclude" />
            <button ref={closeButtonRef} type="button" className="mobile-menu-close" onClick={closeSidebar} aria-label="Close main menu">×</button>
          </div>
        )}
        <div className="sidebar-item">
          <Link to="/" aria-current={active === "DashBoard" ? "page" : undefined}>
            <span
              className={
                active === "DashBoard" ? "active d-flex justify-center" : ""
              }
            >
              <img src={active === "DashBoard" ?dashboardActive:dashBoard} alt="" aria-hidden="true" style={{ height:isMobile?"3rem":"1.5rem"}} />
              Dashboard
            </span>
          </Link>
        </div>
        {sidebarOpen && <div className="sidebar-item">
          <Link to="/profile" aria-current={active === "Profile" ? "page" : undefined}>
            <span
              className={
                active === "Profile" ? "active d-flex justify-center" : ""
              }
            >
              <img src={user} alt="" aria-hidden="true" style={{ height:isMobile?"3rem":"1.5rem"}} />
              Profile
            </span>
          </Link>
        </div>}
        {/* <div className="sidebar-item">
          <Link to="/bookshelf" >
            <span className={active ==='BookShelf'?'active':''}>BookShelf</span>
          </Link>
        </div> */}
        <div className="sidebar-item">
          <Link to="/docaccess/new" aria-current={active === "docAccessibility" ? "page" : undefined}>
            <span
              className={
                active === "docAccessibility"
                  ? "active d-flex justify-center"
                  : ""
              }
            >
              <img src={active === "docAccessibility"?docAccessActive:docAccess} alt="" aria-hidden="true" style={{ height:isMobile?"3rem":"1.5rem"}} />
              Document Accessibility
            </span>
          </Link>
        </div>
        {/*
        <div className="sidebar-item">
          <Link to="/avaccess">
            <span
              className={
                active === "avAccessibility"
                  ? "active d-flex justify-center"
                  : ""
              }
            >
              <img src={active === "avAccessibility"
                  ?avAccessActive:avAccess} alt="" style={{ height:isMobile?"3rem":"1.5rem"}} />
              Audio/Video Accessibility
            </span>
          </Link>
        </div>
        */}
        {/* <div className="sidebar-item">
          <span>
            <Accordion className="sidebar-accordion">
              <Accordion.Item eventKey="0">
                <Accordion.Header as="div" className={active ==='Accessibility'?'active':''}>Accessibility</Accordion.Header>
                <Accordion.Body>
                  <ul>
                    <li>
                      <Link to="/docaccess">Document Accessibility</Link>
                    </li>
                    <li>
                      <Link to="/avaccess">Audio-Video Accessibility</Link>
                    </li>
                  </ul>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </span>
        </div> */}
        <div className="sidebar-item">
          <Link to="/opportunity" aria-current={active === "Opportunity" ? "page" : undefined}>
            <span
              className={
                active === "Opportunity" ? "active d-flex justify-center" : ""
              }
            >
              <img src={active === "Opportunity" ?careerDiscoveryActive:careerDiscovery} alt="" aria-hidden="true" style={{ height:isMobile?"3rem":"1.5rem"}} />
              Career Discovery
            </span>
          </Link>
        </div>
        <div className="sidebar-item">
          <Link to="/jobs" aria-current={active === "Jobs" ? "page" : undefined}>
            <span
              className={
                active === "Jobs" ? "active d-flex justify-center" : ""
              }
            >
              <img src={active === "Jobs" ?jobListActive:jobList} alt="" aria-hidden="true" style={{ height:isMobile?"3rem":"1.5rem"}} />
              Jobs Listing
            </span>
          </Link>
        </div>
        {localStorage.getItem("scope") === "library" && (
          <div className="sidebar-item">
            <Link to="/library" aria-current={active === "Library" ? "page" : undefined}>
              <span
                className={
                  active === "Library" ? "active d-flex justify-center" : ""
                }
              >
                <img src={active === "Library" ?libraryActive:library} alt="" aria-hidden="true" style={{height:isMobile?"3rem":"1.5rem"}} />
                Accessible Library
              </span>
            </Link>
          </div>
        )}
        <div className="sidebar-item">
          <Link to="/chatbot" aria-current={active === "Chatbot" ? "page" : undefined}>
            <span
              className={
                active === "Chatbot" ? "active d-flex justify-center" : ""
              }
            >
              <img src={active === "Chatbot" ?infoActive:info} alt="" aria-hidden="true" style={{ height:isMobile?"3rem":"1.5rem"}} />
              Information Access
            </span>
          </Link>
        </div>
        <div className="sidebar-item">
          <Link to="/news" aria-current={active === "News" ? "page" : undefined}>
            <span
              className={
                active === "News" ? "active d-flex justify-center" : ""
              }
            >
              <img src={active === "News" ?newsActive:news} alt="" aria-hidden="true" style={{ height:isMobile?"3rem":"1.5rem"}} />
              News
            </span>
          </Link>
        </div>
        <div className="sidebar-item">
          <Link to="/browser-agent" aria-current={active === "BrowserAgent" ? "page" : undefined}>
            <span
              className={
                active === "BrowserAgent" ? "active d-flex justify-center" : ""
              }
            >
              <img src={active === "BrowserAgent" ?browserAgentActive:browserAgent} alt="" aria-hidden="true" style={{ height:isMobile?"3rem":"1.5rem"}} />
              Browser Agent
            </span>
          </Link>
        </div>
        <div className="sidebar-item">
          <Link to="/fellowship" aria-current={active === "Fellowship" ? "page" : undefined}>
            <span
              className={
                active === "Fellowship" ? "active d-flex justify-center" : ""
              }
            >
              <img src={user} alt="" aria-hidden="true" style={{ height:isMobile?"3rem":"1.5rem"}} />
              Fellowship Program
            </span>
          </Link>
        </div>
         <div className="sidebar-item">
          <Link to="/itutor" aria-current={active === "ITutor" ? "page" : undefined}>
            <span
              className={
                active === "ITutor" ? "active d-flex justify-center" : ""
              }
            >
              <img src={user} alt="" aria-hidden="true" style={{ height:isMobile?"3rem":"1.5rem"}} />
              I-Tutor
            </span>
          </Link>
        </div>
        {isMobile && (
          <div className="mobile-nav-utilities">
            <div className="mobile-accessibility-control">
              <span>Accessibility settings</span>
              <AccessibilityAccordion />
            </div>
            <button type="button" className="mobile-logout" onClick={handleLogout}>
              <img src={logout} alt="" aria-hidden="true" />
              Log out
            </button>
          </div>
        )}
      </nav>
      {isMobile && <div className="sidebar-bottom-border" aria-hidden="true"></div>}
    </>
  );
}

export default SideBar;
